module.exports = __webpack_public_path__ + "french-polynesia.svg?9e3240e0edf9cdaf50efe7aaf698d848";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/french-polynesia.svg
// module id = 168
// module chunks = 10